import React, { useEffect, useState, memo, useMemo, useCallback, useRef } from 'react';
import style from './MenuContentItems.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
import _, { cloneDeep, isEmpty, groupBy } from 'lodash';
import cn from 'classnames';
import GroupButtonsSkeleton from './GroupButtonsSkeleton';
import MenuItemsSkeleton from './MenuItemsSkeleton';
import { backgroundChange } from '@components/Orders/orderUtils';
import {
  mapStringCartToObject,
  renderExcludeModifier,
  getObjectValue,
  urlSearchParams,
} from '@utility/utills';
import { TouchableButton } from '@components/common/Touchable/index';
import { LABEL } from '../../../../veriables';
import MenuItem from './MenuItem';
import OpenPriceModal from '../Modals/OpenPriceModal';
import {
  addToCart,
  pushModifiersGroupData,
  setPosition,
} from '@reducers/orders';
import { generateRandomString } from '@utility/helperFunction';
import { List } from 'react-window';

const ITEM_HEIGHT = 51;

const ITEMS_PER_ROW = 3;

const MenuItemRow = ({ index, style: rowStyle, items, btnColor, auth, loading, serverAppTheme, openPricePopUp }) => {
  const rowItems = items.slice(index * ITEMS_PER_ROW, index * ITEMS_PER_ROW + ITEMS_PER_ROW);
  return (
    <div style={{ ...rowStyle, display: 'flex' }}>
      {rowItems.map((item, colIdx) => {
        const globalIdx = index * ITEMS_PER_ROW + colIdx;
        return (
          <div
            key={item.menuItemId}
            className={cn(
              style.heightWithBag,
              item?.menuItem?.buttonColor || btnColor ? '' : style.oContainerCardBg,
              'o-card p-0 od-container-card-background'
            )}
            style={{
              flex: '0 0 32.5%',
              minWidth: '136px',
              backgroundColor: backgroundChange(item?.menuItem?.buttonColor, btnColor),
              borderTopLeftRadius: index === 0 && colIdx === 0 ? '5px' : undefined,
              borderTopRightRadius: index === 0 && colIdx === 2 ? '5px' : undefined,
            }}
          >
            <MenuItem
              data={item}
              auth={auth}
              idx={globalIdx}
              loading={loading}
              serverAppTheme={serverAppTheme}
              openPricePopUp={openPricePopUp}
            />
          </div>
        );
      })}
    </div>
  );
};

const menuGroupProccessed = {};
const MenuContentItems = ({ ...props }) => {
  const {
    searchString,
    menuItem,
    menuCard,
    serverAppTheme,
    loading,
    menusList,
    menuIndex,
    auth,
    menuItemsHashTable,
    modifierGroupsHashTable,
    modifiersHashTable,
    activeMenuItemId,
    deviceInfo,
    coursesHashTable,
    addToCart,
    selectedMenuGroupId,
    processedMenu,
  } = props; // Redux imports

  const navigate = useNavigate();
  const [subMenuItemList, setSubMenuItemList] = useState(processedMenu ?? []);
  const [menuItemList, setMenuItemList] = useState(processedMenu ?? []);
  const [isProcessingMenu, setIsProcessingMenu] = useState(
    menuItem.length === 0
  );
  const [groupId, setGroupId] = useState(null);
  const [activeButton, setActiveButton] = useState(null);
  const [mapGroupIdToItems, setMapGroupIdToItems] = useState(new Map());
  const [isOpenPricePopup, setIsOpenPricePopup] = useState(false);
  const [count, setCount] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const [selectedMenuItem, setSelectedMenuItem] = useState({});
  const [error, setError] = useState();
  const scrollContainerRef = useRef(null);
  const subMenuScrollRef = useRef(null);
  // Track the previous menuItem reference to detect genuine menu updates (isUnchanged === false).
  const menuItemRef = useRef(menuItem);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    if (subMenuScrollRef.current) {
      subMenuScrollRef.current.scrollLeft = 0;
    }
    setActiveButton(null);
    setGroupId(null);
  }, [selectedMenuGroupId]);

  useEffect(() => {
    let map = new Map();
    subMenuItemList.forEach(item => {
      map.set(item.groupName, item.items);
    });
    setMapGroupIdToItems(map);
    setGroupId(null);
  }, [subMenuItemList]);
  useEffect(() => {
    let subMenuItemList = [];
    if (menuItem.length === 0) {
      return;
    }
    // When the menuItem reference changes, new menu data arrived from the backend
    // (isUnchanged === false). Clear the stale processed-menu cache so categories
    // and tiles are re-computed from the fresh menu instead of serving old data.
    if (menuItemRef.current !== menuItem) {
      Object.keys(menuGroupProccessed).forEach(key => delete menuGroupProccessed[key]);
      menuItemRef.current = menuItem;
    }
    if (menuGroupProccessed[selectedMenuGroupId]) {
      setSubMenuItemList(menuGroupProccessed[selectedMenuGroupId]);
      setMenuItemList(menuGroupProccessed[selectedMenuGroupId]);
      setIsProcessingMenu(false);
      return;
    }
    setIsProcessingMenu(true);
    if (searchString === '') {
      const groupedMenu = _.chain((menuItem || []).filter(e => !e.linkedItem))
        .groupBy('groupName')
        .map((value, key) => ({
          groupName: key,
          items: value,
          index: _.minBy(value, o => o.index).index,
        }))
        .value();

      subMenuItemList = _.sortBy(groupedMenu, [
        d => {
          const name = d.groupName;
          return (!name || name === 'null') ? 1 : 0;
        },
        d => d.index,
      ]);
      let map = new Map();
      subMenuItemList.forEach(item => {
        map.set(item.groupName, item.items);
      });
    } else {
      const subMenuList = _.orderBy(
        (menuItem || []).filter(e => !e.linkedItem),
        [menu => menu.menuItem?.name.toLowerCase()],
        ['asc']
      );
      subMenuItemList.push({ items: subMenuList });
      let map = new Map();
      map.set('', subMenuList);
    }
    if (subMenuItemList.length !== 0) {
      menuGroupProccessed[selectedMenuGroupId] = subMenuItemList;
    }
    setSubMenuItemList(subMenuItemList);
    setMenuItemList(subMenuItemList);
    setIsProcessingMenu(false);
  }, [menuItem, searchString]);

  const isMenuItemGroupPresent = useMemo(
    () =>
      menuItemList?.[0] &&
      (menuItemList?.length > 1 ||
        (menuItemList?.length > 0 && menuItemList[0]?.items?.groupName)),
    [menuItemList]
  );

  const hasNamedSubGroups = useMemo(
    () => menuItemList.some(g => g.groupName && g.groupName !== 'null' && g.groupName !== ''),
    [menuItemList]
  );

  const nullSubMenuGroup = useMemo(
    () => hasNamedSubGroups ? menuItemList.find(g => g.groupName === 'null' || !g.groupName) : null,
    [menuItemList, hasNamedSubGroups]
  );
  const getButtonColor = useCallback(() => {
    if (menusList[menuIndex]) {
      const menuTypeId = Number(window.sessionStorage.getItem('menuTypeId'));
      const screen = menusList[menuIndex].screens.find(
        d => d.internalId === menuTypeId
      );
      if (screen) return screen.buttonColor;
      const initialScreen = menusList[menuIndex].screens[0] || [];
      return initialScreen?.buttonColor;
    }
    return '';
  }, [menusList, menuIndex]);

  const btnColor = useMemo(() => getButtonColor(), [getButtonColor]);
  const renderSubMenuItemTiles = () => {
    if (loading || isProcessingMenu || (menuItem?.length > 0 && subMenuItemList.length === 0)) {
      return <MenuItemsSkeleton rows={5} />;
    } else if (subMenuItemList?.[0]?.items?.length > 0) {
      return subMenuItemList.map(subMenuList => (
        <div
          className={cn(style.menuItemsList, 'w-100')}
          key={`${subMenuList?.groupName}-${subMenuList.index}`}
        >
          {(() => {
            const isNullGroup = !subMenuList.groupName || subMenuList.groupName === 'null';
            const showLabel = isNullGroup ? hasNamedSubGroups : !!subMenuList.groupName;
            const label = isNullGroup ? LABEL().OTHERS : subMenuList.groupName;
            return showLabel ? (
              <>
                <div
                  id={subMenuList.groupName}
                  className={cn(
                    'fs-14 mb-2 fw-600 od-menu-header link-text-color od-cardTxt-instructionalText',
                    style.menuHeader
                  )}
                />
                <div
                  className={cn(
                    style.menuHeader,
                    style.oCategoryTitleFont,
                    'fw-700 fs_18'
                  )}
                >
                  {label}
                </div>
              </>
            ) : null;
          })()}
          {(() => {
            const filteredItems =
              (groupId
                ? mapGroupIdToItems.get(groupId)
                : subMenuList.items
              )?.filter(data => data !== null && !data.linkedItem) ?? [];
            const rowCount = Math.ceil(filteredItems.length / ITEMS_PER_ROW);
            // const listHeight = Math.min(rowCount * ITEM_HEIGHT, 400);
            const listHeight = rowCount * ITEM_HEIGHT;
            return (
              <List
                rowComponent={MenuItemRow}
                rowCount={rowCount}
                rowHeight={ITEM_HEIGHT}
                defaultHeight={listHeight}
                style={{ height: listHeight, overflowY: 'none' }}
                rowProps={{
                  items: filteredItems,
                  btnColor,
                  auth,
                  loading,
                  serverAppTheme,
                  openPricePopUp,
                }}
              />
            );
          })()}
        </div>
      ));
    } else if (menuItem.length === 0) {
      return (
        <div
          className={cn(
            searchString !== '' ? style.oTextPrimary : style.oTextPrimary,
            'h-100 d-flex justify-content-center align-items-center p-10 fs_18 fw-400 text-center'
          )}
          style={newStyle.noItemFound}
        >
          {searchString !== ''
            ? LABEL().ITEM_NOT_FOUND
            : LABEL().MENU_ITEM_NOT_ITEM}
        </div>
      );
    }
    return null;
  };
  const newStyle = useMemo(
    () => ({
      menuItemsStyle: { color: serverAppTheme?.primary_text },
      subMenuStyle: {
        // paddingBottom: `${Math.max(footerHeight, 0)}px`, // Check footer Height changes later
        backgroundColor: serverAppTheme?.background_color,
        overflowX: 'hidden',
      },
      noItemFound: { color: serverAppTheme?.noRecord },
    }),
    [
      serverAppTheme,
      //footerHeight //TODO: Check footer Height changes later
    ]
  );
  const onClickGroupId = useCallback(
    subMenuList => {
      if (activeButton === subMenuList?.groupName) {
        setActiveButton(null);
        setGroupId(null);
        setSubMenuItemList(menuItemList);
      } else {
        setSubMenuItemList([subMenuList]);
        setActiveButton(subMenuList?.groupName);
        setGroupId(subMenuList.groupName);
      }
    },
    [activeButton, menuItemList]
  );

  const validatePrice = useCallback(
    val => {
      const error = {};
      const regex = /^(?:\d+(\.\d*)?|\.\d+)$/;
      const isValid = regex.test(inputValue);

      if (isEmpty(inputValue)) {
        error.price = 'Enter Price';
        setError('Enter Price');
      }
      if (!isEmpty(inputValue) && !isValid) {
        error.price = 'Enter Valid Price';
        setError('Enter Valid Price');
      }
      return error;
    },
    [inputValue]
  );

  const calculateModifierAmount = useCallback(
    modifierData => {
      let modiferPrice = 0;
      const modifierObject = mapStringCartToObject(
        [{ modifiers: modifierData }],
        []
      );

      const getModifierAmount = modifierList => {
        modifierList.forEach(mod => {
          modiferPrice +=
            mod.quantity *
            Number(
              _.find(
                modifierGroupsHashTable[mod.modifierGroupId].modifierLinks,
                d => d.modifierId === Number(mod.modifierId)
              ).price
            );
          if (mod.modifiers) {
            getModifierAmount(mod.modifiers);
          }
        });
      };
      getModifierAmount(modifierObject[0].modifiers);
      return modiferPrice;
    },
    [modifierGroupsHashTable]
  );

  const updateExcludeModifier = useCallback(
    cartItemsList => {
      const cartTemp = cloneDeep(cartItemsList);
      cartTemp.forEach(cartItem => {
        renderExcludeModifier(
          menuItemsHashTable[cartItem.menuItemId].modifierGroupLinks,
          cartItem,
          modifierGroupsHashTable,
          modifiersHashTable,
          ''
        );
        if (cartItem?.modifiers?.length > 0) {
          cartItem.modifiers
            .filter(d => d.includes('|') && !d.includes('-0'))
            .forEach(d => {
              renderExcludeModifier(
                modifiersHashTable[d.split('|')[0].split('-')[0]]
                  .modifierGroupLinks,
                cartItem,
                modifierGroupsHashTable,
                modifiersHashTable,
                `${d.split('|')[0]}|`
              );
            });
        }
      });
      return cartTemp;
    },
    [menuItemsHashTable, modifierGroupsHashTable, modifiersHashTable]
  );

  const renderInitialData = useCallback(
    menuItemId => {
      const modifierList = menuItemsHashTable[
        menuItemId
      ].modifierGroupLinks.map(item => ({
        ...item,
        ...modifierGroupsHashTable[item.modifierGroupId],
      }));
      const preSelectModList = [];
      modifierList.forEach(modGroup => {
        if (
          modGroup.hiddenMenuId === activeMenuItemId &&
          modGroup.hiddenAutoAddModifierId &&
          modifiersHashTable[modGroup.hiddenAutoAddModifierId]
        ) {
          preSelectModList.push(
            `${modGroup.hiddenAutoAddModifierId}-${modGroup.id}`
          );
        }
      });
      return preSelectModList;
    },
    [
      menuItemsHashTable,
      modifierGroupsHashTable,
      modifiersHashTable,
      activeMenuItemId,
    ]
  );

  const applyModFunction = useCallback(
    cartItemsList => {
      cartItemsList.forEach(cartItem => {
        if (cartItem.modifiers && cartItem.modifiers.length > 0) {
          cartItem.modifiers.forEach(modifier => {
            modifier.split('|').forEach((mod, i) => {
              if (
                mod.split('-')[1] &&
                modifierGroupsHashTable[mod.split('-')[1]]?.applyModFunction
              ) {
                if (
                  i === 0 &&
                  !cartItem.modifiers.includes(
                    `${mod}|${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierId
                    }-${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierGroupId
                    }`
                  )
                ) {
                  cartItem.modifiers.push(
                    `${mod}|${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierId
                    }-${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierGroupId
                    }`
                  );
                } else if (
                  !cartItem.modifiers.includes(
                    `${modifier}|${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierId
                    }-${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierGroupId
                    }`
                  )
                ) {
                  cartItem.modifiers.push(
                    `${modifier}|${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierId
                    }-${modifierGroupsHashTable[mod.split('-')[1]]
                      .modFunctionModifierGroupId
                    }`
                  );
                }
              }
            });
          });
        }
      });
      return cartItemsList;
    },
    [modifierGroupsHashTable]
  );

  const AddToCartToLocal = useCallback(
    (data, openPrice) => {
      const { menuTypeId, menuItemId, price, internalId } = data;
      const itemInfo = menuCard[menuTypeId][menuItemId];
      const dataToSend = {
        quantity: 1,
        price: price || itemInfo?.price,
        menuItemId,
        menuTypeId,
        brandCourseId: itemInfo?.menuItem?.brandCourseId,
        modifiers: renderInitialData(menuItemId),
        note: null,
        menuItemName: (itemInfo?.menuItem || {})?.name,
        serverAppModifierGroupDisplayStyle:
          data?.serverAppModifierGroupDisplayStyle ?? 0,
      };
      let cartItem = updateExcludeModifier([dataToSend]);
      cartItem = applyModFunction(cartItem);
      const modifierObject = getObjectValue(
        () =>
          mapStringCartToObject(
            cartItem,
            [],
            modifiersHashTable,
            modifierGroupsHashTable
          )[0].modifiers,
        []
      );
      dataToSend.modifierObject = modifierObject.filter(e => e.modifierGroupId);
      const modiferPrice = calculateModifierAmount([]);
      const position = getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('position')),
        {}
      );
      const requestData = {
        ...dataToSend,
        note: dataToSend?.note,
        pending: true,
        seatIds: position?.number === -1 ? [] : [position?.seatId],
        price: Number(dataToSend?.price) + modiferPrice,
        menuScreenId: Number(menuTypeId),
        // internalId,
        internalId: internalId ? internalId : new Date().getTime(),
        menuId: menusList[menuIndex]?.id,
        modifiers: dataToSend?.modifierObject,
        modifierData: dataToSend.modifiers,
      };
      requestData.modifierJson = JSON.stringify({ ...requestData, openPrice });
      // eslint-disable-next-line
      const cartData = {
        ...requestData,
        isProcessing: true,
        openPrice,
      };

      if (deviceInfo?.deviceGroup?.serverAppSettings?.enforcePivotSeating) {
        if (
          position?.number !== -1 &&
          coursesHashTable[data.menuItem.brandCourseId]?.pivotSeating
        ) {
          addToCart(cartData);
          const seats = getObjectValue(
            () => JSON.parse(window.sessionStorage.getItem('seat')),
            []
          );
          const availableSeats = seats?.seats?.filter(
            item => item.open === true
          );
          const value = availableSeats?.findIndex(
            object => object.id === position?.id
          );
          if (value < availableSeats?.length - 1) {
            setPosition(availableSeats[value + 1]);
          } else {
            setPosition(availableSeats[0]);
          }
        } else {
          addToCart(cartData);
        }
      } else {
        addToCart(cartData);
      }
    },
    [
      menuCard,
      renderInitialData,
      updateExcludeModifier,
      applyModFunction,
      modifiersHashTable,
      modifierGroupsHashTable,
      calculateModifierAmount,
      menusList,
      menuIndex,
      deviceInfo,
      coursesHashTable,
      addToCart,
      setPosition,
    ]
  );

  const checkRequiredModifierCount = useCallback(
    (menuItemId, menuId) => {
      const requiredModifierList = [];
      menuItemsHashTable[menuItemId].modifierGroupLinks.forEach(item => {
        if (
          modifierGroupsHashTable[item.modifierGroupId].minimum > 0 &&
          modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !== menuId
        ) {
          requiredModifierList.push({ ...item });
        }
        if (modifierGroupsHashTable[item.modifierGroupId].flowRequired) {
          requiredModifierList.push({ ...item });
        }
      });
      return requiredModifierList.length;
    },
    [menuItemsHashTable, modifierGroupsHashTable]
  );

  const handleAddToCart = useCallback(
    (data, qty, openPrice = false) => {
      const { menuTypeId, menuItemId } = data;
      if (
        getObjectValue(
          () => menuCard[menuTypeId][menuItemId].menuItem.linkType,
          0
        ) === 1
      ) {
        navigate(
          `${APP_CONFIG.BASE_URL}/order-item/${menuTypeId}/${menuItemId}?menuId=${menusList[menuIndex].id}&parentMenuItemId=${menuItemId}`
        );
      } else {
        const requiredModLength = checkRequiredModifierCount(
          menuItemId,
          menusList[menuIndex].id
        );
        if (requiredModLength === 0 && !qty) {
          AddToCartToLocal(data, openPrice);
        } else {
          const modifierList = menuItemsHashTable[
            menuItemId
          ].modifierGroupLinks.map(item => ({
            ...item,
            ...modifierGroupsHashTable[item.modifierGroupId],
          }));
          window.sessionStorage.setItem(
            'serverAppModifierGroupDisplayStyle',
            data?.serverAppModifierGroupDisplayStyle ?? 0
          );
          pushModifiersGroupData(modifierList).then(() => {
            navigate(
              `${APP_CONFIG.BASE_URL}/order-item/${menuTypeId}/${menuItemId}?menuId=${menusList[menuIndex].id}&orderType=order`
            );
          });
        }
      }
    },
    [
      menuCard,
      checkRequiredModifierCount,
      AddToCartToLocal,
      menuItemsHashTable,
      modifierGroupsHashTable,
      pushModifiersGroupData,
      navigate,
      menusList,
      menuIndex,
    ]
  );

  const openPricePopUp = useCallback(data => {
    setCount(1);
    setIsOpenPricePopup(true);
    setSelectedMenuItem(data);
    // setOpenDollerClosed(false);
  }, []);

  const submitPrice = () => {
    Array.from({ length: count }).forEach(() => {
      const dataToSend = {
        ...selectedMenuItem,
        price: inputValue,
        internalId: generateRandomString(5),
      };
      handleAddToCart(dataToSend, null, true);
    });
    setIsOpenPricePopup(false);
    setInputValue('');
  };

  return (
    <div className="col-12 px-0">
      {menuItemList.length === 0 ? (
        <GroupButtonsSkeleton count={6} />
      ) : menuItemList.length > 1 && (
        <div
          ref={subMenuScrollRef}
          className="row col-12 flex-nowrap overflowX position-relative"
          style={{
            height: '34px',
            position: 'relative',
            zIndex: 1,
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {menuItemList?.map(
            subMenuList =>
              subMenuList.groupName &&
              subMenuList.groupName !== '' &&
              subMenuList.groupName !== 'null' && (
                <TouchableButton
                  key={subMenuList.groupName}
                  className={cn(style.oRound, 'mr-2 fs_16 fw-600')}
                  onClick={() => onClickGroupId(subMenuList)}
                  style={{
                    background:
                      activeButton === subMenuList.groupName
                        ? serverAppTheme?.secondaryBtn
                        : serverAppTheme?.orderitem_bg,
                    border: `1px solid ${serverAppTheme?.stage_payment_border}`,
                    height: '32px',
                    minWidth: 'fit-content',
                    color: activeButton === subMenuList.groupName ? serverAppTheme?.btn_font_color : ''
                  }}
                  rippleEffect={true}
                >
                  {subMenuList.groupName}
                </TouchableButton>
              )
          )}
          {nullSubMenuGroup && (
            <TouchableButton
              key="others"
              className={cn(style.oRound, 'mr-2 fs_16 fw-600')}
              onClick={() => onClickGroupId(nullSubMenuGroup)}
              style={{
                background:
                  activeButton === nullSubMenuGroup.groupName
                    ? serverAppTheme?.secondaryBtn
                    : serverAppTheme?.orderitem_bg,
                border: `1px solid ${serverAppTheme?.stage_payment_border}`,
                height: '32px',
                minWidth: 'fit-content',
                color: activeButton === nullSubMenuGroup.groupName ? serverAppTheme?.btn_font_color : ''
              }}
              rippleEffect={true}
            >
              {LABEL().OTHERS}
            </TouchableButton>
          )}
        </div>
      )}
      <div className={cn("row col-12", isMenuItemGroupPresent ? 'mt-2' : 'mt-0', style.paddingRight)}>
        {isMenuItemGroupPresent && (
          <div
            className="h-2 col-12"
            style={{ borderBottom: `2px solid ${serverAppTheme?.itemFacts}` }}
          ></div>
        )}
      </div>
      <div className="row col-12 pr-0" style={{ height: isMenuItemGroupPresent ? '400px' : '440px' }}>
        {/* order screen Items: serverapp || isDriveThru */}
        <div
          ref={scrollContainerRef}
          className={cn('overflowY col-12 px-0 h-100')}
          style={newStyle.subMenuStyle}
        >
          {renderSubMenuItemTiles()}
        </div>
      </div>
      {isOpenPricePopup && (
        <OpenPriceModal
          isOpenPricePopup={isOpenPricePopup}
          openPricePopUp={openPricePopUp}
          handleClosePopup={() => setIsOpenPricePopup(false)}
          count={count}
          setCount={setCount}
          onSubmit={submitPrice}
          inputValue={inputValue}
          setInputValue={setInputValue}
          validatePrice={validatePrice}
          selectedMenuItem={selectedMenuItem}
          // setIsOpenPricePopup={setIsOpenPricePopup}
          // setOpenDollerClosed={setOpenDollerClosed}
          auth={auth}
        />
      )}
    </div>
  );
};

MenuContentItems.propTypes = {
  menuItem: PropTypes.array.isRequired,
  searchString: PropTypes.string.isRequired,
  serverAppTheme: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  menusList: PropTypes.array.isRequired,
  menuIndex: PropTypes.number.isRequired,
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = ({ orders, oauth, theme }) => ({
  loading: orders.loading,
  searchString: orders.searchString,
  menuItem: orders.screenMenuItemsList,
  auth: oauth.authInfo,
  serverAppTheme: theme.serverAppTheme,
  menuIndex: orders.menuIndex,
  menusList: orders.menusList,
  menuCard: orders.menuCardList,
  menuItemsHashTable: orders.menuItemsHashTable,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  modifiersHashTable: orders.modifiersHashTable,
  activeMenuItemId:
    Number(urlSearchParams('menuId')) ||
    orders?.menusList?.[orders?.menuIndex]?.id ||
    0,
  deviceInfo: oauth.deviceInformation,
  coursesHashTable: orders.coursesHashTable,
  selectedMenuGroupId: orders.selectedMenuGroupId,
  processedMenu: orders.processedMenu,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addToCart,
      pushModifiersGroupData,
      setPosition,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(memo(MenuContentItems));
